import { render, staticRenderFns } from "./FavVideo.vue?vue&type=template&id=ddde0e38&scoped=true&"
import script from "./FavVideo.vue?vue&type=script&lang=js&"
export * from "./FavVideo.vue?vue&type=script&lang=js&"
import style0 from "./FavVideo.vue?vue&type=style&index=0&id=ddde0e38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddde0e38",
  null
  
)

export default component.exports